// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoalEditorPanel__goalIcon___AiXYI {
    position: relative;
    top: 4px;
    left: 3px;
    font-size: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goalIcon": `GoalEditorPanel__goalIcon___AiXYI`
};
module.exports = ___CSS_LOADER_EXPORT___;
